import { type TypePolicy } from '@apollo/client';

export const StudentSubscriptionInfo: TypePolicy = {
    keyFields: false,
    merge: true,
};
